import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  token: localStorage.getItem('authToken') || null,
  isAuthenticated: !!localStorage.getItem('authToken'), // Derive from token presence
  customerId: localStorage.getItem('customerId') || null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, { payload }) => {
      state.user = payload.user;
      state.token = payload.token;
      state.isAuthenticated = !!payload.token;
       state.customerId = payload.customerId || null; // Set customerId from payload
      localStorage.setItem('authToken', payload.token);
      localStorage.setItem('isAuthenticated', !!payload.token);
      localStorage.setItem('user', JSON.stringify(payload.user));
      localStorage.setItem('customerId', payload.customerId || ''); // Store customerId in localStorage
      // Store expiration time if available, e.g., 1 hour from now
      const expirationTime = new Date().getTime() + 3600 * 1000; // 1 hour
      localStorage.setItem('tokenExpiration', expirationTime);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.customerId = null;
      localStorage.removeItem('authToken');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('user');
      localStorage.removeItem('customerId');
      localStorage.removeItem('tokenExpiration');
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth?.token;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectCustomerId = (state) => state.auth?.customerId;
